import React from "react";
import './App.css';
import { Toaster } from "react-hot-toast";
import { AllRoutes } from './Pages/AllRoutes/AllRoutes';
import { useUserAuth } from "./Context/UserAuthContext";
import Login from "./Pages/Login/Login";
import ModalPopup from "./Pages/Modalpopup/Modalpopup";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  // const {loading} = useUserAuth();
  const token = localStorage.getItem("userToken");
  // const navigate = useNavigate()

  // if (loading) return <div className="loader-container"><div className="traffic-loader"></div></div>


  return (
    <>
  <ToastContainer
  style={{ zIndex: 9999999, marginTop: "60px" }}
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  newestOnTop
/>


      {token ? (
        <>
          <ScrollToTop />
          <div className="sidebar-dashboard-container">
            <AllRoutes />
          </div>
        </>
      ) : (
        <AllRoutes />
      )}
    </>
  );
}

export default App;
